export const siteMeta = {
  siteName: "Maxitherm Works",
  siteUrl: "https://maxithermworks.com",
  defaultTitle: "Maxitherm Works | Industrial Heating, Cooling, and Water Solutions",
  defaultDescription:
    "Maxitherm Works delivers industrial heating, cooling, water treatment, and energy solutions as an IBR Approved Firm - Class I and trusted Thermax Channel Associate.",
  defaultImage: "/images/logo_wide.png",
}

export function buildCanonical(pathname: string): string {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`
  return `${siteMeta.siteUrl}${normalizedPath === "/" ? "" : normalizedPath}`
}

export type PageMeta = {
  title: string
  description: string
  pathname: string
}
